import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=254fbfbc&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"
import style0 from "./Result.vue?vue&type=style&index=0&id=254fbfbc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254fbfbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('254fbfbc')) {
      api.createRecord('254fbfbc', component.options)
    } else {
      api.reload('254fbfbc', component.options)
    }
    module.hot.accept("./Result.vue?vue&type=template&id=254fbfbc&scoped=true", function () {
      api.rerender('254fbfbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page2/Result.vue"
export default component.exports